import { Dialog, Loading } from "vant";
import Vue from 'vue';
import VueJsonp from "vue-jsonp";
import App from './App.vue';
import './assets/iconfont/iconfont.css';
import globalFunction from './assets/js/global_function.js'; //全局函数
import router from './router';
import store from './store';

const wx = require('weixin-js-sdk')
console.log(wx);
Vue.config.ignoredElements = ['wx-open-launch-weapp'];

Vue.use(Dialog)
Vue.use(VueJsonp)
Vue.use(router)
Vue.use(Loading)
Vue.use(globalFunction)
Vue.config.productionTip = false
Vue.prototype.wx = wx
require('./assets/js/sha1.min')
require('animate.css/animate.min.css')

// 换设备链接
// Vue.prototype.ImeiUrl = 'https://cardserver-test.china-m2m.com/weixin/question/eqReplaceMent?status=0'
Vue.prototype.ImeiUrl = 'https://cardserver.china-m2m.com/weixin/question/eqReplaceMent?status=0'
Vue.prototype.isActivityImg = true // 是否显示活动轮博图， 活动浮窗
Vue.prototype.activityUrl = 'https://cardserver.china-m2m.com/weixin/activity/dragon_boat_festival' // 活动地址

// Vue.prototype.mifiUrl = 'https://card.qiqwo.com'  // 19楼电商
//  修改mifiUrl 记得去http.js里面修改一下requestUrl
// Vue.prototype.mifiUrl = 'http://eqtest-lz.china-m2m.com'
// Vue.prototype.mifiUrl = 'http://localhost:8082' 
// Vue.prototype.mifiUrl = 'http://192.168.0.133:8082'
//正式 http://mifi.china-m2m.com
// 测试 http://mifitest.china-m2m.com
//改title
Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})

// let UA = navigator.userAgent.toLowerCase()

// if (/(ylkids_android)/.test(UA)) {
//   let str = window.jsInterface.GetToken()
//   localStorage.setItem('token', str)
//   console.log(99877, str)
// } else if (/(ios1.1.0)/.test(UA)) {
//   window.webkit.messageHandlers.getIosToken.postMessage(null)
// }


//适配IOS
window.appToken = function (msg) {
  localStorage.setItem("token", msg);
};

require('./assets/js/router.guard') // 全局路由守卫


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')